export default __webpack_public_path__ + "static/media/avatar.5deb33b4.png";